import { BrowserRouter, Route, Routes } from "react-router-dom";
import { ScrollToTop } from "./components/ScrollToTop";

import Index from "./pages/Index";
import CalendarPage from "./pages/CalendarPage";
import OrdoPage from "./pages/OrdoPage";
import MassPage from "./pages/MassPage";
import ReadingsPage from "./pages/ReadingsPage";
import PrayersPage from "./pages/PrayersPage";
import { NIP19Page } from "./pages/NIP19Page";
import NotFound from "./pages/NotFound";

export function AppRouter() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/calendar" element={<CalendarPage />} />
        <Route path="/ordo" element={<OrdoPage />} />
        <Route path="/readings" element={<ReadingsPage />} />
        <Route path="/prayers" element={<PrayersPage />} />
        <Route path="/mass/:dateStr" element={<MassPage />} />
        {/* NIP-19 route for npub1, note1, naddr1, nevent1, nprofile1 */}
        <Route path="/:nip19" element={<NIP19Page />} />
        {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}
export default AppRouter;
